// extracted by mini-css-extract-plugin
export default {"container":"Silent_container__Fe8c7","video":"Silent_video__q-WWw"};